import React, { useState, useEffect, useRef } from 'react';
import rfLogo from '../Images/redfibre logo.png';
import { Link } from 'react-router-dom';
import cartIcon from '../Images/cart-icon.png';

function Navbar({ page }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(null);
  
  // Toggle mobile menu
  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  
  // Design text rotation
  const descriptions = ["Strategy", "Design", "Development", "Motion", "Social"];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % descriptions.length);
    }, 2000);
    
    return () => clearInterval(interval);
  }, [descriptions.length]);
  
  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (navRef.current && !navRef.current.contains(event.target) && isOpen) {
        setIsOpen(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <nav className={`${scrolled ? 'scrolled' : ''} ${isOpen ? 'nav-open' : ''}`} ref={navRef}>
      <Link className="rfLogo" to={'/'} onClick={() => setIsOpen(false)}>
        <img src={rfLogo} alt="Red Fibre Logo" />
        <div className="desBox">
          <div className="des" style={{ transform: `translateY(-${currentIndex * 100}%)` }}>
            {descriptions.map((description, index) => (
              <div key={index} className="de">
                {description}
              </div>
            ))}
          </div>
        </div>
      </Link>
      
      <button className="navbar-toggler" onClick={toggleNavbar} aria-label="Toggle navigation">
        <div className={`hamburger ${isOpen ? 'active' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
      
      <ul className={`navComp ${isOpen ? 'open' : ''}`}>
        <li className={page === "serv" ? "active" : ""}>
          <Link to={'/services'} onClick={() => setIsOpen(false)}>SERVICES</Link>
        </li>
        <li className={page === "sol" ? "active" : ""}>
          <Link to={'/solutions'} onClick={() => setIsOpen(false)}>SOLUTIONS</Link>
        </li>
        <li className={page === "cont" ? "active" : ""}>
          <Link to={'/contact'} onClick={() => setIsOpen(false)}>CONTACT</Link>
        </li>
        <li className={page === "prof" ? "active" : ""}>
          <Link to={'/profile'} onClick={() => setIsOpen(false)}>PROFILE</Link>
        </li>
        <li className="cart-icon">
          <Link to="/cart" onClick={() => setIsOpen(false)}>
            <img src={cartIcon} alt="Cart" />
          </Link>
        </li>
      </ul>

      {/* Mobile menu overlay background */}
      {isOpen && <div className="menu-overlay" onClick={toggleNavbar}></div>}
    </nav>
  );
}

export default Navbar;
